import { Avatar, IconButton, ListItem, ListItemAvatar, ListItemText, Toolbar, Tooltip } from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import AvatarEngineer from 'src/assets/images/technician.png';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white
  },
  backButton: {
    marginRight: theme.spacing(2),
    '@media (min-width: 864px)': {
      display: 'none'
    }
  },
  user: {
    flexShrink: 0,
    flexGrow: 1
  },
  activity: {
    display: 'flex',
    alignItems: 'center'
  },
  statusBullet: {
    marginRight: theme.spacing(1)
  },
  search: {
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center',
    flexBasis: 300,
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      flex: '1 1 auto'
    }
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  }
}));

function ConversationToolbar({ conversation, className }) {
  const classes = useStyles();
  const history = useHistory();

  const openCentralPaperDetail = () => {
    const SessionUser = getUser();
    if (SessionUser.ServiceShopId === 99) {
      history.push(`/CentralPaperControl/FIS_NO/${conversation.FIS_NO}`);
    }
  }
  return (
    <Toolbar
      className={clsx(classes.root, className)}>
      <Tooltip title="Back">
        <IconButton
          className={classes.backButton}
          component={RouterLink}
          edge="start"
          to="/chat">
          <KeyboardBackspaceIcon />
        </IconButton>
      </Tooltip>
      <div className={classes.user}>
        <ListItem onClick={() => openCentralPaperDetail()}>
          <ListItemAvatar>
            <Avatar
              alt="Person"
              className={classes.avatar}
              src={AvatarEngineer}
            />
          </ListItemAvatar>
          <ListItemText primary={conversation.otherUserName} secondary={conversation.FIS_NO} />
          <ListItemText primary={conversation.MUSTERI} secondary={conversation.BASVURU_NEDENI} />
        </ListItem>
      </div>
    </Toolbar>
  );
}
ConversationToolbar.propTypes = {
  className: PropTypes.string,
  conversation: PropTypes.object.isRequired
};

export default ConversationToolbar;
